const buttonLabelSelector = '.button, a.btn, button:not([role="tab"]), input[type="submit"]';

function toProperCase(value) {
  return value
    .toLocaleLowerCase()
    .replace(/(^|[\s(/-])([a-z])/g, (_match, boundary, letter) => `${boundary}${letter.toLocaleUpperCase()}`);
}

function normalizeButtonLabel(button) {
  if (button.hasAttribute('data-preserve-label-case')) return;

  if (button instanceof HTMLInputElement) {
    button.value = toProperCase(button.value);
    return;
  }

  const walker = document.createTreeWalker(button, NodeFilter.SHOW_TEXT);
  const textNodes = [];

  while (walker.nextNode()) {
    textNodes.push(walker.currentNode);
  }

  textNodes.forEach(node => {
    const normalizedText = toProperCase(node.nodeValue);

    if (node.nodeValue !== normalizedText) {
      node.nodeValue = normalizedText;
    }
  });
}

function normalizeButtons(root = document) {
  if (root.nodeType === Node.ELEMENT_NODE && root.matches(buttonLabelSelector)) {
    normalizeButtonLabel(root);
  }

  root.querySelectorAll?.(buttonLabelSelector).forEach(normalizeButtonLabel);
}

normalizeButtons();

new MutationObserver(mutations => {
  mutations.forEach(mutation => {
    if (mutation.type === 'characterData') {
      const button = mutation.target.parentElement?.closest(buttonLabelSelector);
      if (button) normalizeButtonLabel(button);
      return;
    }

    mutation.addedNodes.forEach(node => {
      if (node.nodeType === Node.ELEMENT_NODE) {
        normalizeButtons(node);
      } else if (node.nodeType === Node.TEXT_NODE) {
        const button = node.parentElement?.closest(buttonLabelSelector);
        if (button) normalizeButtonLabel(button);
      }
    });
  });
}).observe(document.body, {
  childList: true,
  characterData: true,
  subtree: true
});
